import { useEffect } from "react";
import { useAuth } from "./Info";

const GlobalThemeSetter = () => {
  const { allDataHome } = useAuth();

  useEffect(() => {
    if (!allDataHome?.site) return;
    const root = document.documentElement;
    root.style.setProperty('--cor1', allDataHome.site.cor1 || '#000000');
    root.style.setProperty('--cor2', allDataHome.site.cor2 || '#9e6868');
    root.style.setProperty('--cor3', allDataHome.site.cor3 || '#000000');
    root.style.setProperty('--cor4', allDataHome.site.cor4 || '#FFFFFF');
    root.style.setProperty('--cor5', allDataHome.site.cor5 || '#FFFFFF');
    root.style.setProperty('--cor6', allDataHome.site.cor6 || '#FFFFFF');
    root.style.setProperty('--cor7', allDataHome.site.cor7 || '#FFFFFF');
    root.style.setProperty('--cor8', allDataHome.site.cor8 || '#FFFFFF');
    root.style.setProperty('--cor9', allDataHome.site.cor9 || '#FFFFFF');
    root.style.setProperty('--fonte-principal', "'Roboto Condensed', sans-serif");
    // ...adicione os outros se quiser
  }, [allDataHome]);

  return null; // Este componente não renderiza nada
};

export default GlobalThemeSetter;
